import { postAPI } from "../../../../api/frameworksApi";

const CMDB_TOOLS_BY_ORG_URL = (window.BE_URL ?? "") + "/api/v1/cmdb/tools/by-org";

/** Omitted/empty array on any field = no restriction on that scope level. */
export interface CmdbToolsByOrgScope {
  groupIds?: string[];
  organizationIds?: string[];
  divisionIds?: string[];
  departmentIds?: string[];
  applicationIds?: string[];
}

export interface CmdbToolByOrgInstance {
  id: string;
  toolName: string;
  toolType: string;
  toolStatus: string;
  instanceName: string;
  environment: string;
}

/** Tool instances reachable from the given org scope, for the Agent Health and
 * Asset Coverage pages' "Tool" filter option list. */
export const fetchCmdbToolsByOrg = async (
  scope: CmdbToolsByOrgScope,
): Promise<CmdbToolByOrgInstance[]> => {
  const res = await postAPI(CMDB_TOOLS_BY_ORG_URL, scope);
  return Array.isArray(res?.data?.tools)
    ? res.data.tools
    : Array.isArray(res?.data)
      ? res.data
      : Array.isArray(res)
        ? res
        : [];
};
